import { Component, Input } from '@angular/core';
import { ProviderOffice } from 'app/core/models/provider-office.model';

import { OfficeComponent } from '../../../shared/components/office/office.component';
import { ProviderOfficeFaxStatusPipe } from '../../../shared/pipes/provider-office-fax-status.pipe';

@Component({
    selector: 'app-provider-office',
    templateUrl: './provider-office.component.html',
    styleUrls: ['./provider-office.component.scss'],
    imports: [OfficeComponent, ProviderOfficeFaxStatusPipe]
})
export class ProviderOfficeComponent {
  @Input() providerOffice: ProviderOffice;
}
